import { splitLanguagePair } from './languagePairs';
import { canonicalizeLanguageKey } from './languageIdentity';

export const findTranslationPairForTargetLanguage = (
  pairs: string[] | undefined,
  sourceLanguage: string,
  targetLanguage: string,
): string => {
  const sourceKey = canonicalizeLanguageKey(sourceLanguage);
  const targetKey = canonicalizeLanguageKey(targetLanguage);
  if (!targetKey) return '';

  const allPairs = Array.isArray(pairs) ? pairs : [];
  const exactPair = allPairs.find((pair) => {
    const { sourceLang, targetLang } = splitLanguagePair(pair || '');
    return (
      canonicalizeLanguageKey(sourceLang) === sourceKey &&
      canonicalizeLanguageKey(targetLang) === targetKey
    );
  });
  if (exactPair) return exactPair;

  return (
    allPairs.find((pair) => {
      const { targetLang } = splitLanguagePair(pair || '');
      return canonicalizeLanguageKey(targetLang) === targetKey;
    }) || ''
  );
};
